<!-- <div class="mt-16 flex-row flex-jc-none" *ngrxLet="routeData$ as routeData">
  <button
    mat-icon-button
    class="back-btn"
    [attr.aria-label]="'ARIA_LABEL.BACK' | translate"
    id="header_back-btn"
    [routerLink]="routeData.backUrl"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h1 id="header-title">{{ routeData.title | translate }}</h1>
</div> -->
@if (isLoadingShippingAddress$ | async) {
  <pbb-loading-overlay
    [titleKey]="'CHECKOUT.SHIPPING_OPTIONS.CHECKING_TITLE'"
    [subtitleKey]="'CHECKOUT.SHIPPING_OPTIONS.CHECKING_SUBTITLE'"
  ></pbb-loading-overlay>
  } @else {
<div class="content_main-container">
  <ng-container *ngrxLet="routeData$ as routeData">
    @if(shippingOptionsError) {
      <pbb-notice-banner 
      noticeVariant="error"
      [showCloseButton]="false"
      [dismissable]="false"
      [duration]="0"
      [noticeTitle]="'CHECKOUT.SHIPPING_OPTIONS.INVALID_POSTAL_CODE' | translate"
      [noticeMessage]="'CHECKOUT.SHIPPING_OPTIONS.INVALID_POSTAL_CODE_DESC' | translate"
      ></pbb-notice-banner>
    }
    <h1 class="main-title mb-25" id="user-portal_view-address-title">
      {{ (routeData.editPage ? 'COMMON.EDIT_ADDRESS.CHANGE_ADDRESS' : 'COMMON.EDIT_ADDRESS.ADD_ADDRESS') | translate }}
    </h1>
  </ng-container>
  <ng-container *ngrxLet="defaultShippingAddressRef$ as defaultShippingAddressRef">
    <pbb-address-edit
      [address]="address"
      (submit$)="saveShippingAddress($event)"
      [isDefaultAddress]="address && defaultShippingAddressRef === address.shipping_address_ref"
      [isLoading]="isLoading"
      [isMerchantAddress]="isMerchantAddress"
      [hasInvalidPostalCodeError]="shippingOptionsError?.code === ShippingOptionErrorCode.InvalidPostalCode"
    ></pbb-address-edit>
  </ng-container>
</div>
  }
